import {Moment} from 'moment-timezone';
import {DurationTuple} from '@shared/api/model/timestamp';

export class TimestampUtils {

  static readonly INCLUSIVITY_DAY_SHIFT_DURATION: DurationTuple = {amount: 1, unit: 'day'};
  private static readonly INCLUSIVITY_SHIFT_DURATION: DurationTuple = {amount: 1, unit: 'ms'};

  public static exclusiveToInclusive(ts: Moment, duration: DurationTuple = TimestampUtils.INCLUSIVITY_SHIFT_DURATION): Moment {
    return ts.clone().subtract(duration.amount, duration.unit);
  }

  public static inclusiveToExclusive(ts: Moment, duration: DurationTuple = TimestampUtils.INCLUSIVITY_SHIFT_DURATION): Moment {
    return ts.clone().add(duration.amount, duration.unit);
  }
}
